export const categories = [
  {
    slug: 'recommended',
    name: '推荐域名',
    description: '精选稳定可用的狼友域名入口，优先级最高推荐',
    icon: 'ri-star-line',
  },
  {
    slug: 'main',
    name: '主域名',
    description: '狼友域名官方主站入口地址，最新域名实时更新',
    icon: 'ri-home-line',
  },
  {
    slug: 'mirror',
    name: '镜像域名',
    description: '狼友域名镜像站点，多线路保障访问稳定',
    icon: 'ri-refresh-line',
  },
  {
    slug: 'backup',
    name: '备用入口',
    description: '狼友域名备用访问地址，防止主站无法访问时使用',
    icon: 'ri-shield-line',
  },
  {
    slug: 'anti-lost',
    name: '防失联域名',
    description: '狼友域名防失联专用入口，永久书签收藏告别失联',
    icon: 'ri-bookmark-line',
  },
  {
    slug: 'resources',
    name: '资源站点',
    description: '高质量资源站点收录导航，一站式访问优质资源',
    icon: 'ri-links-line',
  },
];

export const domains = [
  {
    id: 1,
    name: '狼友官方主站',
    url: 'https://langyou01.com',
    status: 'online',
    category: 'recommended',
    description: '狼友域名官方主站入口，提供最全面的资源导航和域名信息聚合服务，实时更新确保访问稳定。',
    speed: '极快',
    uptime: '99.9%',
  },
  {
    id: 2,
    name: '狼友备用域名一',
    url: 'https://langyou02.com',
    status: 'online',
    category: 'recommended',
    description: '狼友域名第一备用入口，与主站数据同步更新，当主站访问繁忙时可使用此域名获得同样体验。',
    speed: '快',
    uptime: '99.7%',
  },
  {
    id: 3,
    name: '狼友主域名新地址',
    url: 'https://langyou-new.com',
    status: 'online',
    category: 'main',
    description: '狼友域名最新主域名地址，采用全新服务器部署，访问速度更快更稳定。',
    speed: '极快',
    uptime: '99.8%',
  },
  {
    id: 4,
    name: '狼友主域名入口二',
    url: 'https://langyou-main.com',
    status: 'online',
    category: 'main',
    description: '狼友域名主域名第二入口，提供与主站一致的完整服务，推荐收藏备用。',
    speed: '快',
    uptime: '99.5%',
  },
  {
    id: 5,
    name: '狼友镜像站点A',
    url: 'https://mirror-langyou-a.com',
    status: 'online',
    category: 'mirror',
    description: '狼友域名镜像站点A线，采用CDN加速分发，全国多节点部署保障访问体验。',
    speed: '极快',
    uptime: '99.9%',
  },
  {
    id: 6,
    name: '狼友镜像站点B',
    url: 'https://mirror-langyou-b.com',
    status: 'online',
    category: 'mirror',
    description: '狼友域名镜像站点B线，独立服务器部署，与主站数据实时同步。',
    speed: '快',
    uptime: '99.6%',
  },
  {
    id: 7,
    name: '狼友镜像站点C',
    url: 'https://mirror-langyou-c.com',
    status: 'offline',
    category: 'mirror',
    description: '狼友域名镜像站点C线，当前正在维护升级中，预计近期恢复访问。',
    speed: '-',
    uptime: '95.2%',
  },
  {
    id: 8,
    name: '狼友备用入口一',
    url: 'https://backup-langyou-1.com',
    status: 'online',
    category: 'backup',
    description: '狼友域名备用入口一号，建议添加到浏览器书签，防止主域名无法访问。',
    speed: '快',
    uptime: '99.4%',
  },
  {
    id: 9,
    name: '狼友备用入口二',
    url: 'https://backup-langyou-2.com',
    status: 'online',
    category: 'backup',
    description: '狼友域名备用入口二号，多线路冗余保障，确保随时可以访问。',
    speed: '中等',
    uptime: '99.2%',
  },
  {
    id: 10,
    name: '狼友防失联永久入口',
    url: 'https://langyou-permanent.com',
    status: 'online',
    category: 'anti-lost',
    description: '狼友域名防失联永久入口，地址长期有效不变，建议永久收藏此域名地址。',
    speed: '快',
    uptime: '99.8%',
  },
  {
    id: 11,
    name: '狼友防失联紧急入口',
    url: 'https://langyou-emergency.com',
    status: 'online',
    category: 'anti-lost',
    description: '狼友域名防失联紧急备用入口，当其他域名均无法访问时的最后保障。',
    speed: '中等',
    uptime: '99.1%',
  },
  {
    id: 12,
    name: '优质资源聚合站A',
    url: 'https://resource-hub-a.com',
    status: 'online',
    category: 'resources',
    description: '收录大量优质网络资源的聚合站点，分类清晰检索便捷，资源更新频繁。',
    speed: '快',
    uptime: '99.3%',
  },
  {
    id: 13,
    name: '站长工具资源库',
    url: 'https://webmaster-tools.com',
    status: 'online',
    category: 'resources',
    description: '专注于站长工具和网络资源的导航站点，提供SEO工具、域名查询等实用功能。',
    speed: '极快',
    uptime: '99.7%',
  },
  {
    id: 14,
    name: '资源爱好者社区',
    url: 'https://resource-fans.com',
    status: 'online',
    category: 'resources',
    description: '资源爱好者交流社区，分享优质资源站点和域名信息，互助解决访问问题。',
    speed: '快',
    uptime: '99.5%',
  },
];